import React, { useEffect } from "react"

import { CircularProgress } from "@mui/material"

import { useTranslations } from "@cirrus/core/i18n/provider"
import { Alert } from "@cirrus/ui-kit-ts/src/components/molecules/Alert"

import { useLoginFetcher, useLoginService } from "../providers/LoginService"
import { useNavigationService } from "../providers/NavigationService"

export const ExternalLogin = () => {
  const { i18n } = useTranslations()
  const { language } = useTranslations()
  const { redirectToAfterExternalLogin, search } = useNavigationService()
  const { login, error, submitting } = useLoginFetcher()
  const { persistLoginPreferences } = useLoginService()

  useEffect(() => {
    if (submitting || error) return

    (async () => {
      try {
        const { data } = await login({
          grant_type: "external_session_token", browser_token: null
        }, { session: search.session })

        persistLoginPreferences({ language })

        redirectToAfterExternalLogin(data)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [search.session, language, submitting, error])

  if (error?.error === "invalid_client") return <Alert icon={false}
                                                       severity="error">{i18n("Login:NotAllowedIp")}</Alert>

  if (error?.error === "invalid_grant") return <Alert icon={false}
                                                      severity="error">{i18n("Login:InvalidSessionToken")}</Alert>

  return <CircularProgress style={{ margin: "2rem auto" }}/>
}
